import { useStoredPreference } from '@cmg/auth';
import { loggerUtil } from '@cmg/common';
import { FormControlLabel, Switch } from '@cmg/design-system';
import React, { useCallback } from 'react';

export type OptInFeatureToggleProps = Readonly<{
  /**
   * Local storage key to store the user preference.
   */
  preferenceKey: string;
  label?: string;
  /**
   * Initial value for the toggle switch.
   * @default false
   */
  initialValue?: boolean;
  mixpanelEventName?: string;
}>;

export const OptInFeatureToggle: React.FC<OptInFeatureToggleProps> = ({
  preferenceKey,
  label = 'Try Enhanced Mode',
  initialValue = false,
  mixpanelEventName,
}) => {
  const mixpanel = loggerUtil.useMixpanel();

  const [checked, setIsChecked] = useStoredPreference({
    key: preferenceKey,
    initialValue,
    storageType: 'Local',
  });

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsChecked(event.target.checked);

      if (mixpanelEventName) {
        mixpanel.log(mixpanelEventName, {
          preferenceKey,
          value: event.target.checked,
        });
      }
    },
    [mixpanel, mixpanelEventName, preferenceKey, setIsChecked]
  );

  return (
    <FormControlLabel
      control={<Switch size="medium" checked={checked} onChange={handleChange} />}
      label={label}
      sx={{ marginRight: 0 }}
    />
  );
};
